import { Autocomplete, Box, Button, Card, Chip, Dialog, DialogActions, DialogContent, DialogTitle, Divider, Grid, IconButton, MenuItem, Stack, TextField, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { ApiAddBusinessChecklistQuestion, ApiCreateBusinessChecklist, ApiGetChecklistTemplate, ApiGetChecklistTemplateQuestions } from '../../apiService/Core/Apicall'
import { toast } from 'react-toastify'
import { CancelOutlined } from '@mui/icons-material'
import * as Yup from "yup";
import { useFormik } from 'formik'
import { useNavigate } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { RootState } from '../../global/config/Reducer'
import dayjs from 'dayjs'


function CreateChecklist() {
    const [templateList, setTemplateList] = useState<any>([])
    const [selectedTemplate, setSelectedTemplate] = useState<any>()
    const [templateQuestion, setTemplateQuestion] = useState<any>()
    const [openTemplate, setOpenTemplate] = useState<boolean>(false)
    const [open, setOpen] = useState(false);
    const clientEntity = useSelector((state: RootState) => state.clientEntity.selectedEntity)
    const navigate = useNavigate()


    const getTemlateList = async () => {
        try {
            const data = `?isActive=true`
            const res = await ApiGetChecklistTemplate(data)
            if (res?.data) {
                const templates = res.data.map((item: any) => ({
                    checklistTemplateId: item?.checklistTemplateId,
                    templateName: item?.templateName,
                }));
                setTemplateList(res?.data)
            }
        } catch (error: any) {
            toast.error(error?.messgae || "Something went wrong")
        }
    }

    const getTemlateQuestion = async (id: number) => {
        try {
            const data = `?checklistTemplateId=${id}`
            const res = await ApiGetChecklistTemplateQuestions(data)
            if (res?.data) {

                let categories = [...(res?.data?.categories || [])];

                if (res?.data?.categoryDisplayOrder) {
                    const order = res?.data?.categoryDisplayOrder
                        .split(",")
                        .map((id: string) => Number(id.trim()));

                    categories.sort(
                        (a: any, b: any) =>
                            order.indexOf(a.checklistCategoryId) -
                            order.indexOf(b.checklistCategoryId)
                    );
                } else {
                    categories.sort(
                        (a: any, b: any) =>
                            (a.questions?.[0]?.displayOrder ?? 0) -
                            (b.questions?.[0]?.displayOrder ?? 0)
                    );
                }
                setTemplateQuestion(res?.data)
                setOpenTemplate(true)
            }
        } catch (error: any) {
            toast.error(error?.messgae || "Something went wrong")
        }
    }
    useEffect(() => {
        getTemlateList()
    }, [])


    const validationSchema = Yup.object({
        checklistName: Yup.string()
            .required("Checklist name is required"),

        checklistDescription: Yup.string()
            .required("Checklist description is required"),

        emailIds: Yup.array()
            .min(1, "At least one email is required")
            .of(Yup.string().email("Invalid email address")),

        type: Yup.string()
            .required("Checklist type is required"),

        scheduleType: Yup.string()
            .required("Schedule type is required"),

        requiredCount: Yup.number()
            .when("scheduleType", {
                is: (scheduleType: string) => scheduleType !== "INTERVAL_DAYS",
                then: (schema) =>
                    schema
                        .required("Required count is required")
                        .min(1, "Must be at least 1")
                        .integer("Must be a whole number"),
                otherwise: (schema) => schema.notRequired(),
            }),

        intervalDays: Yup.number()
            .when("scheduleType", {
                is: "INTERVAL_DAYS",
                then: (schema) =>
                    schema
                        .required("Interval days is required")
                        .min(1, "Must be at least 1")
                        .integer("Must be a whole number"),
                otherwise: (schema) => schema.notRequired(),
            }),

        scheduleDay: Yup.number()
            .when("scheduleType", {
                is: (scheduleType: string) =>
                    ["WEEKLY", "MONTHLY", "BI_MONTHLY", "QUARTERLY", "HALF_YEARLY", "YEARLY"]
                        .includes(scheduleType),
                then: (schema) =>
                    schema
                        .required("Schedule day is required")
                        .when("scheduleType", {
                            is: "WEEKLY",
                            then: (weeklySchema) =>
                                weeklySchema
                                    .min(0, "Select a valid day")
                                    .max(6, "Select a valid day")
                                    .integer("Select a valid day"),
                            otherwise: (otherSchema) =>
                                otherSchema
                                    .min(1, "Date must be between 1 and 31")
                                    .max(31, "Date must be between 1 and 31")
                                    .integer("Date must be a whole number"),
                        }),
                otherwise: (schema) => schema.notRequired(),
            }),
    });


    const copyTemplate = async (BusinesschecklistId: number) => {
        try {
            const data = { businessCheckListId: BusinesschecklistId, checklistTemplateId: selectedTemplate }
            const res = await ApiAddBusinessChecklistQuestion(data)
            if (res?.data) {
                setOpen(false)
                handleClose()
                setSelectedTemplate(null)
                navigate(-1)
            }
        } catch (error: any) {
            toast.error(error?.message || "Something went wrong")
        }
    }


    const formik = useFormik({
        initialValues: {
            checklistName: "",
            checklistDescription: "",
            emailIds: [],
            scheduleType: "",
            requiredCount: 1,
            intervalDays: "",
            type: "BUSINESS",
            scheduleStartDate: "",
            scheduleDay: "",
        },
        validationSchema,
        enableReinitialize: true,
        onSubmit: async (values: any) => {
            const payload = {
                businessCheckListTitle: values.checklistName,
                businessCheckListDesc: values.checklistDescription,
                emailIds: values.emailIds.join(","),
                clientEntityId: clientEntity,
                scheduleStartDate: dayjs(values.scheduleStartDate).format("YYYY-MM-DD"),
                type: values.type,
                scheduleType: values.scheduleType,
                // ...(values.scheduleType === "DAILY" ? { requiredCount: values.requiredCount } : { intervalDays: values.intervalDays })
                ...(values.scheduleType === "INTERVAL_DAYS"
                    ? { intervalDays: values.intervalDays }
                    : {
                        requiredCount: values.requiredCount,
                        ...(values.scheduleType === "WEEKLY"
                            ? { scheduleDayOfWeek: values.scheduleDay }
                            : !["DAILY"].includes(values.scheduleType)
                                ? { scheduleDayOfMonth: values.scheduleDay }
                                : {}),
                    }),
            };
            try {
                const res = await ApiCreateBusinessChecklist(payload)
                if (res?.status) {
                    copyTemplate(res?.data?.businessCheckListId)
                }
            } catch (error: any) {
                toast.error(error?.message || "something went wrong")
            }
        },
    });

    const handleClose = () => {
        setOpen(false);
        formik.resetForm();
    };

    return (
        <Box>
            <Grid container spacing={2}>
                {
                    templateList?.map((item: any) => (
                        <Grid size={{ xs: 12, md: 6, lg: 4, xl: 3 }} className='border bg-light-main p-3 border-10'>
                            <Box className='d-flex flex-column h-100'>
                                <Box flex={1}>
                                    <Typography variant='h6' className='text-dark fw-bold' gutterBottom>{item?.templateName}</Typography>
                                    <Typography variant='body2' className='text-dark'>{item?.templateDescription}</Typography>
                                    <Chip
                                        label={item?.entityTypeId?.entityTypeName || "MANUAL"}
                                        size="small"
                                        sx={{
                                            backgroundColor: `var(--primary-light-main-color)`,
                                            color: "var(--primary-color)",
                                            fontWeight: 700,
                                            px: 2
                                        }}
                                    />
                                </Box>
                                <Box className='d-flex align-items-center gap-2 mt-2'>
                                    <Button className='btn-outlined' variant='outlined' onClick={() => { getTemlateQuestion(item?.checklistTemplateId) }} fullWidth>View Template</Button>
                                    <Button className='btn-main' onClick={() => { setSelectedTemplate(item?.checklistTemplateId); setOpen(true) }} fullWidth>Use Template</Button>
                                </Box>
                            </Box>
                        </Grid>
                    ))
                }
            </Grid>

            <Dialog
                open={openTemplate}
                onClose={() => setOpenTemplate(false)}
                maxWidth="lg"
                fullWidth
            >
                <DialogTitle fontWeight={700}>
                    <Box className='d-flex align-items-center justify-content-between'>
                        {templateQuestion?.templateName}
                        <IconButton onClick={() => { setOpenTemplate(false); setTemplateQuestion([]); setSelectedTemplate(null) }}><CancelOutlined /></IconButton>
                    </Box>
                </DialogTitle>

                <DialogContent dividers sx={{ bgcolor: "#fafafa" }}>
                    {templateQuestion?.categories?.map((category: any) => (
                        <Box key={category.checklistCategoryId} mb={4}>
                            {/* Category Header */}
                            <Chip
                                className=''
                                label={category.categoryName}
                                sx={{
                                    mb: 2,
                                    px: 1,
                                    fontWeight: 700,
                                    bgcolor: "var(--primary-light-main-color)",
                                    color: "var(--primary-color)",
                                    borderRadius: "8px",
                                    fontSize: 15,
                                }}
                            />

                            {/* Questions */}
                            {category.questions.map((question: any, index: number) => (
                                <Card
                                    key={question.checklistTemplateQuestionId}
                                    elevation={0}
                                    sx={{
                                        border: "1px solid var(--primary-color)",
                                        borderRadius: 2,
                                        mb: 3,
                                        p: 2,
                                    }}
                                >
                                    {/* Top Information */}
                                    <Typography fontWeight={700} fontSize={22}>
                                        Question ID: #{question.checklistQuestionId}
                                        <Typography component="span" fontWeight={500}>
                                            {" "}
                                            | Category: {category.categoryName} | Type:{" "}
                                            {question.qType === "R" ? "Radio Rating" : question.qType}
                                            {" | "}Question Order: {question.displayOrder}
                                        </Typography>
                                    </Typography>

                                    {/* Question */}
                                    <Typography mt={2} fontWeight={700} fontSize={18}>
                                        Q: {question.question}
                                    </Typography>

                                    {/* Question Type */}
                                    {/* <Chip
                                        label={question.qType}
                                        size="small"
                                        sx={{
                                            mt: 1,
                                            bgcolor: "#E9E5DA",
                                            color: "#7B6A34",
                                            fontWeight: 700,
                                        }}
                                    /> */}

                                    {/* Options */}
                                    <Box mt={2}>
                                        {question.qOptionJson.map((option: any, i: number) => (
                                            <Typography key={option.optionId} mb={1}>
                                                {i + 1}. {option.value} ({option.optionScore}){" "}
                                                {option.isPass ? "(good)" : "(poor)"}
                                            </Typography>
                                        ))}
                                    </Box>

                                    <Typography mt={2}>
                                        <b>Description:</b>{" "}
                                        {question.questionDescription || "N/A"}
                                    </Typography>

                                    <Typography mt={2}>
                                        <b>Hint:</b> {question.questionHint || "N/A"}
                                    </Typography>
                                </Card>
                            ))}
                        </Box>
                    ))}
                </DialogContent>
            </Dialog>
            <Dialog
                open={open}
                maxWidth="md"
                fullWidth
                sx={{ zIndex: "1302" }}
            >
                <form onSubmit={formik.handleSubmit}>
                    <DialogContent
                        className="p-4"
                        sx={{ paddingTop: "10px !important" }}
                    >
                        <Box className="d-flex justify-content-between my-4">
                            <Typography variant="h5">
                                Create Checklist
                            </Typography>
                            <IconButton onClick={() => handleClose()}>
                                <CancelOutlined />
                            </IconButton>
                        </Box>


                        <Box display="flex" flexDirection="column" gap={3}>
                            <TextField
                                fullWidth
                                label="Checklist Name"
                                name="checklistName"
                                value={formik.values.checklistName}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                error={
                                    formik.touched.checklistName &&
                                    Boolean(formik.errors.checklistName)
                                }
                                helperText={
                                    formik.touched.checklistName &&
                                    typeof formik.errors.checklistName == "string" &&
                                    formik.errors.checklistName
                                }
                            />

                            <TextField
                                fullWidth
                                multiline
                                rows={4}
                                label="Checklist Description"
                                name="checklistDescription"
                                value={formik.values.checklistDescription}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                error={
                                    formik.touched.checklistDescription &&
                                    Boolean(formik.errors.checklistDescription)
                                }
                                helperText={
                                    formik.touched.checklistDescription &&
                                    typeof formik.errors.checklistDescription === "string" &&
                                    formik.errors.checklistDescription
                                }
                            />

                            <Autocomplete
                                multiple
                                freeSolo
                                options={[]}
                                value={formik.values.emailIds}
                                onChange={(_, value) =>
                                    formik.setFieldValue("emailIds", value)
                                }
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label="Email IDs"
                                        placeholder="Type email and press Enter"
                                        error={
                                            formik.touched.emailIds &&
                                            Boolean(formik.errors.emailIds)
                                        }
                                        helperText={
                                            formik.touched.emailIds &&
                                                typeof formik.errors.emailIds === "string"
                                                ? formik.errors.emailIds
                                                : ""
                                        }
                                    />
                                )}
                            />

                            <TextField
                                select
                                fullWidth
                                label="CheckList View"
                                name="type"
                                value={formik.values.type}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                SelectProps={{
                                    MenuProps: {
                                        style: {
                                            zIndex: 1400,
                                        },
                                    },
                                }}
                                error={
                                    formik.touched.type &&
                                    Boolean(formik.errors.type)
                                }
                                helperText={
                                    formik.touched.type &&
                                        typeof formik.errors.type === "string"
                                        ? formik.errors.type
                                        : ""
                                }
                            >
                                <MenuItem value="BUSINESS">Sites</MenuItem>
                                <MenuItem value="AREA_MANAGER">Areas</MenuItem>
                            </TextField>

                            <TextField
                                select
                                fullWidth
                                label="Schedule Type"
                                name="scheduleType"
                                value={formik.values.scheduleType}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                SelectProps={{
                                    MenuProps: {
                                        style: {
                                            zIndex: 1400,
                                        },
                                    },
                                }}
                                error={
                                    formik.touched.scheduleType &&
                                    Boolean(formik.errors.scheduleType)
                                }
                                helperText={
                                    formik.touched.scheduleType &&
                                        typeof formik.errors.scheduleType === "string"
                                        ? formik.errors.scheduleType
                                        : ""
                                }
                            >
                                <MenuItem value="DAILY">DAILY</MenuItem>
                                <MenuItem value="INTERVAL_DAYS">INTERVAL DAYS</MenuItem>
                                <MenuItem value="WEEKLY">WEEKLY</MenuItem>
                                <MenuItem value="MONTHLY">MONTHLY</MenuItem>
                                <MenuItem value="BI_MONTHLY">BI_MONTHLY</MenuItem>
                                <MenuItem value="QUARTERLY">QUARTERLY</MenuItem>
                                <MenuItem value="HALF_YEARLY">HALF_YEARLY</MenuItem>
                                <MenuItem value="YEARLY">YEARLY</MenuItem>
                            </TextField>

                            <TextField
                                fullWidth
                                type="date"
                                label="Start Date"
                                name="scheduleStartDate"
                                value={formik.values.scheduleStartDate}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                inputProps={{
                                    min: dayjs().format("YYYY-MM-DD"),
                                }}
                                error={
                                    formik.touched.scheduleStartDate &&
                                    Boolean(formik.errors.scheduleStartDate)
                                }
                                helperText={
                                    formik.touched.scheduleStartDate &&
                                        typeof formik.errors.scheduleStartDate === "string"
                                        ? formik.errors.scheduleStartDate
                                        : ""
                                }
                            />

                            {/* {formik.values.scheduleType === "DAILY" && ( */}
                            <TextField
                                fullWidth
                                type="number"
                                label="Required Count"
                                name="requiredCount"
                                value={formik.values.requiredCount}
                                onChange={formik.handleChange}
                                inputProps={{ min: 1 }}
                                error={
                                    formik.touched.requiredCount &&
                                    Boolean(formik.errors.requiredCount)
                                }
                                helperText={
                                    formik.touched.requiredCount &&
                                        typeof formik.errors.requiredCount === "string"
                                        ? formik.errors.requiredCount
                                        : ""
                                }
                            />
                            {/* )} */}
                            {["YEARLY", "HALF_YEARLY", "QUARTERLY", "BI_MONTHLY", "MONTHLY", "WEEKLY"].includes(
                                formik.values.scheduleType
                            ) && (
                                    <TextField
                                        select
                                        fullWidth
                                        label={formik.values.scheduleType === "WEEKLY" ? "Schedule Day" : "Schedule Date"}
                                        name="scheduleDay"
                                        value={formik.values.scheduleDay}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        error={
                                            formik.touched.scheduleDay &&
                                            Boolean(formik.errors.scheduleDay)
                                        }
                                        helperText={
                                            formik.touched.scheduleDay &&
                                                typeof formik.errors.scheduleDay === "string"
                                                ? formik.errors.scheduleDay
                                                : ""
                                        }
                                        SelectProps={{
                                            MenuProps: {
                                                style: {
                                                    zIndex: 1400,
                                                },
                                            },
                                        }}
                                    >
                                        {formik.values.scheduleType === "WEEKLY"
                                            ? [
                                                { label: "Sunday", value: 0 },
                                                { label: "Monday", value: 1 },
                                                { label: "Tuesday", value: 2 },
                                                { label: "Wednesday", value: 3 },
                                                { label: "Thursday", value: 4 },
                                                { label: "Friday", value: 5 },
                                                { label: "Saturday", value: 6 },
                                            ].map((day) => (
                                                <MenuItem key={day.value} value={day.value}>
                                                    {day.label}
                                                </MenuItem>
                                            ))
                                            : Array.from({ length: 31 }, (_, i) => i + 1).map((day) => (
                                                <MenuItem key={day} value={day}>
                                                    {day}
                                                </MenuItem>
                                            ))}
                                    </TextField>
                                )}
                            {formik.values.scheduleType === "INTERVAL_DAYS" && (
                                <TextField
                                    fullWidth
                                    type="number"
                                    label="Interval Days"
                                    name="intervalDays"
                                    value={formik.values.intervalDays}
                                    onChange={formik.handleChange}
                                    error={
                                        formik.touched.intervalDays &&
                                        Boolean(formik.errors.intervalDays)
                                    }
                                    helperText={
                                        formik.touched.intervalDays &&
                                            typeof formik.errors.intervalDays === "string"
                                            ? formik.errors.intervalDays
                                            : ""
                                    }

                                />
                            )}
                        </Box>
                    </DialogContent>

                    <DialogActions
                        sx={{
                            justifyContent: "space-between",
                            mx: 2,
                            mb: 2,
                            mt: 5
                        }}
                    >
                        <Button
                            variant="outlined"
                            className='btn-outlined'
                            onClick={() => handleClose()}
                            sx={{ width: "100%" }}
                        >
                            Cancel
                        </Button>

                        <Button
                            type="submit"
                            className='btn-main'
                            variant="contained"
                            sx={{ width: "100%" }}
                        >
                            Save
                        </Button>
                    </DialogActions>
                </form>
            </Dialog>
        </Box>
    )
}

export default CreateChecklist
